import React, { useState } from "react";
import "./style.scss";
import "react-toastify/dist/ReactToastify.css";
// import { useRouter } from "next/navigation"
import { SignIn } from "./index";
import { useHistory } from "react-router-dom";

interface userProps {
  signIn: any;
  isLoading: boolean;
  handleRedirectSenha: any;
  type: string;
}

export default function Index({
  signIn,
  handleRedirectSenha,
  isLoading,
  type = "login",
}: userProps) {
  const history = useHistory();

  const [loginPassword, setLoginPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [cpf, setCpf] = useState("");
  // const [type, setType] = useState('login');

  // async function checkUser() {
  //   setIsLoading(true);
  //   const backendTokenSliced = process.env.backendToken?.slice(0, 15);

  //   if (!backendTokenSliced) {
  //     throw new Error("backendToken não está definido");
  //   }

  //   const cyptedSocialId = btoa(
  //     encodeURIComponent(cpf.trim() + backendTokenSliced.trim())
  //   );

  //   try {
  //     const check = await checkExistingUser({ social_id: cyptedSocialId });

  //     setCheckedUser(true);
  //     setExistUser(check.exists);
  //   } catch (error: any) {
  //     toast.error(error.response.data.message, {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }

  const handleSocialId = (event: any) => {
    // let value = event.target.value.replace(/\D/g, "");

    // if (value.length >= 11 && value.length <= 14) {
    //   const masked = value.replace(
    //     /(\d{3})(\d{3})(\d{3})(\d{2})/,
    //     "$1.$2.$3-$4"
    //   );
    //   setCpf(masked);
    // }

    // if (value.length < 11) {
    setCpf(event.target.value);
    // }
  };

  // const handleTypeChange = (type: string) => {
  //     // router.push('/');
  // }

  // const router = useRouter();

  const backHome = () => {
    // router.push('/');
    history.replace("/");
  };

  const fieldValidation = (field: string, value: string) => {
    if (!value) return true;
  };

  return (
    <div className="tw-flex tw-flex-col tw-mx-auto tw-w-full tw-py-[80px] tw-px-[80px]">
      <div className="tw-border-[#151A25] tw-border tw-px-5 tw-py-10 tw-my-auto tw-h-full tw-max-h-[860px] tw-w-full tw-text-xl tw-bg-white tw-shadow-lg tw-rounded-[48px] max-lg:tw-px-[20px] tw-max-w-[596px] tw-mx-auto">
        <SignIn.Root
          className="tw-px-[20px] lg:tw-px-[32px] xl:tw-px-[60px] 2xl:tw-px-[80]px tw-gap-[80px]"
        >
          <SignIn.Title
            text={"Login"}
            className="tw-mt-3 max-md:tw-max-w-full max-md:tw-text-4xl "
          />

          <div className="tw-self-start tw-flex tw-flex-col tw-w-full">
            <SignIn.Input
              type="text"
              name="socialId"
              value={cpf}
              onChange={handleSocialId}
              disabled={isLoading}
              validation="Campo obrigatório"
              showValidation={() => fieldValidation("cpf", cpf)}
              placeholder="Login"
              className="tw-justify-center tw-items-start tw-px-4 tw-py-2.5 tw-mt-28 tw-text-justify tw-whitespace-nowrap tw-bg-white tw-rounded-lg tw-border tw-border-solid tw-border-zinc-500 tw-text-zinc-500 tw-max-md:tw-pr-5 tw-max-md:tw-mt-10 tw-max-md:tw-max-w-full"
            />
            <SignIn.Input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Senha"
              className="tw-justify-center tw-items-start tw-px-4 tw-py-2.5 tw-text-justify tw-whitespace-nowrap tw-bg-white tw-rounded-lg tw-border tw-border-solid tw-border-zinc-500 tw-text-zinc-500 tw-max-md:tw-pr-5 tw-max-md:tw-mt-10 tw-max-md:tw-max-w-full"
              value={loginPassword}
              validation="Campo obrigatório"
              showValidation={() =>
                fieldValidation("loginPassword", loginPassword)
              }
              onChange={(e) => setLoginPassword(e.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  signIn(cpf, loginPassword);
                }
              }}
              disabled={isLoading}
            />
            <div className=" tw-w-full tw-text-right">
              <SignIn.Action
                className="tw-text-[16px] md:tw-text-[18px] tw-text-right tw-text-neutral-800 tw-underline tw-font-semibold tw-underline-offset-4 tw-max-w-full"
                text={"Esqueci minha senha"}
                id="forgotPassword"
                onClick={handleRedirectSenha}
              />
            </div>
            <div className="tw-flex tw-flex-col tw-w-full">
              <SignIn.Action
                id="checkUser"
                onClick={() => {
                  signIn(cpf, loginPassword);
                }}
                text={type == "login" ? "Acessar" : "Próximo"}
                className={`tw-self-start tw-mt-[80px] tw-items-center tw-text-center tw-p-2.5 tw-w-full tw-text-white tw-rounded-lg tw-shadow-sm ${
                  !isLoading
                    ? "tw-bg-[linear-gradient(90deg,#E13441_0%,#FAAE2E_100%)]"
                    : "tw-bg-gray-400"
                }`}
                disabled={isLoading}
              />
            </div>
          </div>
          
        </SignIn.Root>
      </div>
    </div>
  );
}
